import TextBox from 'components/molecules/TextBox';
import routes from 'defs/routes';
import i18n from 'helper/i18n';
import * as React from 'react';
import { memo } from 'react';

const ProgramOverviewZero = () => {
	return (
		<TextBox
			modifier="no-program-lose-weight"
			title={i18n('react.impulsCoach.views.programOverview.emptyProgramList.title')}
			text={i18n('react.impulsCoach.views.programOverview.emptyProgramList.text')}
			buttons={[
				{
					title: i18n('react.impulsCoach.views.programOverview.emptyProgramList.buttons.furtherPrograms'),
					href: routes.program.further.href,
				},
				{
					title: i18n('react.impulsCoach.views.programOverview.emptyProgramList.buttons.toAnamnesis'),
					href: routes.anamnesis.selectCoach.href,
				},
			]}
		/>
	);
};

ProgramOverviewZero.displayName = 'ProgramOverviewZero';

export default memo(ProgramOverviewZero);
